/* TRIO – Fiche produit */
(function () {
  'use strict';
  if (window.__trioPdp) return;
  window.__trioPdp = true;
  var norm = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, ''); };
  var FMT = '{{amount_with_comma_separator}} €';
  var money = function (cents) {
    var v = (cents / 100).toFixed(2), parts = v.split('.');
    var th = function (x, sep) { return x.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return FMT.replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return th(String(Math.round(cents / 100)), ',');
      if (k === 'amount_with_comma_separator') return th(parts[0], '.') + ',' + parts[1];
      if (k === 'amount_no_decimals_with_comma_separator') return th(String(Math.round(cents / 100)), '.');
      if (k === 'amount_with_space_separator') return th(parts[0], ' ') + ',' + parts[1];
      if (k === 'amount_with_apostrophe_separator') return th(parts[0], "'") + '.' + parts[1];
      return th(parts[0], ',') + '.' + parts[1];
    });
  };

  function gallery(root) {
    var track = root.querySelector('.tp-track'); if (!track) return null;
    var slides = track.querySelectorAll('.tp-slide'), thumbs = root.querySelectorAll('.tp-thumbs button');
    var count = root.querySelector('[data-tp-count]'), prog = root.querySelector('.tp-prog i');
    var prev = root.querySelector('.tp-nav--prev'), next = root.querySelector('.tp-nav--next');
    var n = slides.length, cur = 0;
    if (prog) prog.style.setProperty('--w', Math.max(8, 100 / n) + '%');
    function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
    function update() {
      cur = Math.max(0, Math.min(n - 1, idx()));
      if (count) count.textContent = (cur + 1) + ' / ' + n;
      if (prog) { var W = Math.max(8, 100 / n), maxS = (100 / W) * 100 - 100; prog.style.setProperty('--x', (n > 1 ? cur / (n - 1) * maxS : 0) + '%'); }
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
      var at = thumbs[cur]; if (at && at.parentNode) { var p = at.parentNode; var l = at.offsetLeft - p.clientWidth / 2 + at.clientWidth / 2; p.scrollTo({ left: l, behavior: 'smooth' }); }
      if (prev) prev.disabled = cur === 0; if (next) next.disabled = cur === n - 1;
      var mainEl = root.querySelector('.tp-gal__main'); if (mainEl) mainEl.classList.toggle('is-past', cur > 0);
    }
    function go(i, smooth) {
      i = Math.max(0, Math.min(n - 1, i));
      if (smooth === false || Math.abs(i - cur) > 1) {
        track.classList.add('is-jump');
        track.scrollTo({ left: i * track.clientWidth, behavior: 'auto' });
        cur = i; update();
        requestAnimationFrame(function () { requestAnimationFrame(function () { track.classList.remove('is-jump'); }); });
      } else track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    thumbs.forEach(function (b, j) { b.addEventListener('click', function () { go(j); }); });
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });
    window.addEventListener('resize', function () { go(cur, false); });
    update();
    return {
      showColor: function (name) {
        var k = norm(name); if (!k) return;
        for (var i = 0; i < slides.length; i++) { if (norm(slides[i].dataset.file).indexOf(k) > -1) { go(i); return; } }
      }
    };
  }

  function product(sec) {
    var data; try { data = JSON.parse(sec.querySelector('[data-tp-json]').textContent); } catch (e) { return; }
    if (data.moneyFormat) FMT = data.moneyFormat;
    var gal = gallery(sec);
    var form = sec.querySelector('form.tp-form'), idInput = form && form.querySelector('input[name="id"]');
    var swBtns = sec.querySelectorAll('.tp-sw button'), swName = sec.querySelector('[data-tp-swname]');
    var priceEl = sec.querySelector('[data-tp-price]'), cmpEl = sec.querySelector('[data-tp-cmp]'), saveEl = sec.querySelector('[data-tp-save]');
    var add = sec.querySelector('.tp-add'), bar = document.querySelector('.tp-bar'), barBtn = bar && bar.querySelector('button'), barPrice = bar && bar.querySelector('[data-tp-barprice]'), barName = bar && bar.querySelector('[data-tp-barname]');
    var qty = sec.querySelector('.tp-qty input'), err = sec.querySelector('.tp-err');

    function setVariant(v) {
      if (!v) return;
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      if (barPrice) barPrice.textContent = money(v.price);
      if (cmpEl) { cmpEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      if (saveEl) { saveEl.hidden = !(v.compare_at_price > v.price); saveEl.textContent = 'Vous économisez ' + money(v.compare_at_price - v.price); }
      var label = v.available ? add.dataset.label : add.dataset.soldout;
      add.disabled = !v.available; add.textContent = label;
      if (barBtn) { barBtn.disabled = !v.available; barBtn.textContent = v.available ? barBtn.dataset.label : add.dataset.soldout; }
      if (barName) barName.textContent = data.title + ' · ' + v.title;
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    swBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        swBtns.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); x.tabIndex = x === b ? 0 : -1; });
        if (swName) swName.textContent = b.dataset.name;
        var v = data.variants.filter(function (x) { return x.options[data.colorIndex] === b.dataset.name; })[0];
        setVariant(v);
        if (gal) gal.showColor(b.dataset.name);
      });
      b.addEventListener('keydown', function (e) {
        var list = Array.prototype.slice.call(swBtns), i = list.indexOf(b), to = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') to = list[(i + 1) % list.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') to = list[(i - 1 + list.length) % list.length];
        if (to) { e.preventDefault(); to.focus(); to.click(); }
      });
    });

    sec.querySelectorAll('.tp-qty button').forEach(function (b) {
      b.addEventListener('click', function () { var v = parseInt(qty.value, 10) || 1; qty.value = Math.max(1, Math.min(9, v + parseInt(b.dataset.step, 10))); });
    });

    function toast(msg) {
      var t = document.querySelector('.tp-toast'); if (!t) return;
      t.querySelector('span').textContent = msg; t.classList.add('is-on');
      clearTimeout(t.__h); t.__h = setTimeout(function () { t.classList.remove('is-on'); }, 4200);
    }

    function addToCart(btn) {
      if (btn.disabled) return;
      var label = btn.textContent; btn.disabled = true; btn.textContent = 'Ajout…'; if (err) err.hidden = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qty.value, 10) || 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll('.tw-hd__cart b').forEach(function (b) { b.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
          btn.classList.add('is-done'); btn.textContent = 'Ajoutée au panier';
          toast(data.title + ' a été ajoutée au panier.');
          setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; btn.disabled = false; }, 2200);
        })
        .catch(function (e) {
          btn.textContent = label; btn.disabled = false;
          if (err) { err.textContent = (e && e.description) || 'L’ajout n’a pas fonctionné. Réessayez dans un instant.'; err.hidden = false; }
        });
    }
    if (gal && new URL(window.location.href).searchParams.get('variant') && swName) gal.showColor(swName.textContent);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(add); });
    if (barBtn) barBtn.addEventListener('click', function () { addToCart(barBtn); });

    if (bar && 'IntersectionObserver' in window) {
      /* la barre apparaît une fois le bouton d'ajout dépassé, et se retire au-dessus du pied de page */
      var past = false, atFoot = false, foot = document.querySelector('footer, [data-tf]');
      function sync() { bar.classList.toggle('is-on', past && !atFoot); }
      new IntersectionObserver(function (en) {
        var e = en[0]; past = !e.isIntersecting && e.boundingClientRect.top < 0; sync();
      }).observe(add);
      if (foot) new IntersectionObserver(function (en) { atFoot = en[0].isIntersecting; sync(); }).observe(foot);
    }
  }

  function video(root) {
    root.querySelectorAll('[data-tp-video]').forEach(function (v) {
      var b = v.querySelector('button'); if (!b) return;
      b.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + v.dataset.tpVideo + '?autoplay=1&rel=0&modestbranding=1';
        f.title = v.dataset.title || 'Vidéo'; f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; f.allowFullscreen = true;
        v.innerHTML = ''; v.appendChild(f);
      });
    });
  }

  function init(root) { root = root || document; root.querySelectorAll('[data-tp]').forEach(product); video(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
